<section class="title-row" [ngClass]="{ 'modern__title-row': componentData?.layout === 'modern' }">
  <h2 class="typography-sub-heading" [translate]="'TravellerFormComponent:EditTravellerTitle'" *ngIf="!newTraveller">
    Edit traveller
  </h2>
  <h2 class="typography-sub-heading" [translate]="'TravellerFormComponent:AddTravellerTitle'" *ngIf="newTraveller">
    Add traveller
  </h2>
</section>

<form [formGroup]="travellerFormGroup" [ngClass]="{ modern__form: componentData?.layout === 'modern' }">
  <!-- Title -->
  <mat-form-field class="input-container" [ngClass]="{ modern__title: componentData?.layout === 'modern' }">
    <mat-select
      panelClass="traveller-select-overlay"
      id="traveller_title"
      [placeholder]="'TravellerFormComponent:Title' | translate"
      formControlName="title"
    >
      <mat-option [value]="'Mr'"><span [translate]="'TravellerFormComponent:TitleMr'">Mr</span></mat-option>
      <mat-option [value]="'Mrs'"><span [translate]="'TravellerFormComponent:TitleMrs'">Mrs</span></mat-option>
      <mat-option [value]="'Miss'"><span [translate]="'TravellerFormComponent:TitleMiss'">Miss</span></mat-option>
      <mat-option [value]="'Ms'"><span [translate]="'TravellerFormComponent:TitleMs'">Ms</span></mat-option>
    </mat-select>
    <mat-error
      [translate]="'TravellerFormComponent:SelectGenderLabelMsg'"
      ngxErrors="title"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please select a title
    </mat-error>
  </mat-form-field>

  <!-- First name -->
  <mat-form-field class="input-container">
    <input
      id="traveller_first_name"
      matInput
      formControlName="first_name"
      [placeholder]="'TravellerFormComponent:FormFirstNameLabel' | translate"
    />
    <mat-error
      [translate]="'TravellerFormComponent:FormFirstNameErrorMsg'"
      ngxErrors="first_name"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please enter your first name
    </mat-error>
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="first_name"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- Last name -->
  <mat-form-field class="input-container">
    <input
      id="traveller_last_name"
      matInput
      formControlName="last_name"
      [placeholder]="'TravellerFormComponent:EnterLastNameLabel' | translate"
    />
    <mat-error
      [translate]="'TravellerFormComponent:EnterLastNameErrorMsg'"
      ngxErrors="last_name"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please enter your last name
    </mat-error>
    <mat-error
      [translate]="'TravellerFormComponent:FormAZErrorMsg'"
      ngxErrors="last_name"
      ngxError="pattern"
      when="touched"
      role="alert"
    >
      Please only use a-z, hyphens, apostrophes and spaces.
    </mat-error>
  </mat-form-field>

  <!-- Date of birth -->
  <mat-form-field
    class="input-container"
    (click)="dp.open()"
    [ngClass]="{ modern__date: componentData?.layout === 'modern' }"
  >
    <input
      id="traveller_date_of_birth"
      readonly
      matInput
      [matDatepicker]="dp"
      [min]="minAllowedDate || minDate"
      [max]="maxAllowedDate || maxDate"
      (keyup.enter)="dp.open()"
      (keyup.space)="dp.open()"
      formControlName="birth_date"
      class="date-input"
      [placeholder]="'TravellerFormComponent:EnterDatofBirthLabel' | translate"
    />
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker startView="multi-year" [touchUi]="innerWidth < 640" #dp> </mat-datepicker>
    <mat-error
      [translate]="'RequestDialogComponent:ChooseDate'"
      ngxErrors="birth_date"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please select a date
    </mat-error>
  </mat-form-field>

  <!-- Gender -->
  <mat-form-field class="input-container" [ngClass]="{ modern__gender: componentData?.layout === 'modern' }">
    <mat-select
      id="traveller_gender"
      [placeholder]="'TravellerFormComponent:Gender' | translate"
      formControlName="gender"
      panelClass="traveller-select-overlay"
    >
      <mat-option [value]="'male'"><span [translate]="'TravellerFormComponent:TitleMale'">Male</span></mat-option>
      <mat-option [value]="'female'"
        ><span [translate]="'TravellerFormComponent:TitleFemale'">Female</span>
      </mat-option>
    </mat-select>
    <mat-error
      [translate]="'TravellerFormComponent:SelectGenderTypeErrorMsg'"
      ngxErrors="gender"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please select a gender
    </mat-error>
  </mat-form-field>

  <!-- Country -->
  <mat-form-field id="traveller_citizenship" class="input-container">
    <input
      type="text"
      formControlName="citizenship"
      (blur)="checkCitizenship()"
      (keyup)="filterAutocomplete()"
      [placeholder]="'TravellerFormComponent:Citizenship' | translate"
      matInput
      [matAutocomplete]="auto"
    />
    <mat-autocomplete hideSingleSelectionIndicator="true" #auto="matAutocomplete" panelClass="traveller-select-overlay">
      <mat-option
        *ngFor="let country of filteredCountries"
        [value]="country.name"
        (onSelectionChange)="setChosenCountry(country.url)"
      >
        {{ country.name }}
      </mat-option>
    </mat-autocomplete>
    <mat-error
      [translate]="'TravellerFormComponent:CitizenshipErrorMsg'"
      ngxErrors="citizenship"
      ngxError="required"
      when="touched"
      role="alert"
    >
      Please select a citizenship
    </mat-error>
  </mat-form-field>
</form>

<section class="submit-row" [ngClass]="{ 'modern__submit-row': componentData?.layout === 'modern' }">
  <button
    id="delete-current-record"
    *ngIf="!newTraveller"
    aria-label="close"
    (click)="removeTraveller()"
    mat-raised-button
    class="mr-2 remove-button"
  >
    {{ 'ProfileDetails:Delete' | translate }}
  </button>
  <div
    class="action-buttons"
    [ngClass]="{
      'action-buttons--has-seperator': !newTraveller,
      'modern__action-buttons': componentData?.layout === 'modern'
    }"
  >
    <button
      id="cancel-current-traveller-edit"
      aria-label="close"
      (click)="closeForm()"
      mat-raised-button
      class="close-button"
      [ngClass]="{ 'modern__button--close': componentData?.layout === 'modern' }"
    >
      {{ 'PopupForm:Close' | translate }}
    </button>
    <button
      id="save-current-traveller-edit"
      aria-label="submit"
      (click)="submitForm()"
      mat-raised-button
      color="primary"
      [ngClass]="{ 'modern__button--submit': componentData?.layout === 'modern' }"
    >
      {{ 'PopupForm:Submit' | translate }}
    </button>
  </div>
</section>
